import { endOfDay, startOfDay, subMonths, subWeeks } from 'date-fns';

import type { DateRangePreset } from '../date-range-picker';

export function getDefaultPeriodPresets(): DateRangePreset[] {
  const now = new Date();

  return [
    {
      title: 'Last 7 days',
      value: {
        startDate: startOfDay(subWeeks(now, 1)).toISOString(),
        endDate: endOfDay(now).toISOString(),
      },
    },
    {
      title: 'Last 14 days',
      value: {
        startDate: startOfDay(subWeeks(now, 2)).toISOString(),
        endDate: endOfDay(now).toISOString(),
      },
    },
    {
      title: 'Last month',
      value: {
        startDate: startOfDay(subMonths(now, 1)).toISOString(),
        endDate: endOfDay(now).toISOString(),
      },
    },
  ];
}
